import React, { Component } from "react";
import axios from "axios";
import theme from "./App.module.sass";

import { Switch, Route, Redirect } from "react-router-dom";

import AjaxSpinner from "./components/AjaxSpinner/AjaxSpinner";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Products from "./containers/Products/Products";
import Offers from "./containers/Offers/Offers";
import ConfirmOffer from "./containers/ConfirmOffer/ConfirmOffer";
import Identification from "./containers/Identification/Identification";
import NewUser from "./containers/NewUser/NewUser";
import Insurance from "./containers/Insurance/Insurance";
import Payment from "./containers/Payment/Payment";
import Signature from "./containers/Signature/Signature";
import Documents from "./containers/Documents/Documents";
import ErrorModal from "./components/ErrorModal/ErrorModal";
import ModalLgpd from "./components/ModalLgpd/ModalLgpd";

import AppContext from "./contexts/appContext";
import Chat from "./components/Chat/Chat";
import Alert from "./components/Alert/Alert";
import IBCInterceptor from "./containers/IBCInterceptor/IBCInterceptor";
import { changePage } from "./utils/data-layer";
import MaintenanceModal from "./components/MaintenanceModal/MaintenanceModal";
class App extends Component {
  state = {
    loading: false,
    lgpd: false,
    context: {
      error: {},
      pathname: "/produtos",
      product: "",
      maintenanceAccepted: "N",
    },
  };

  componentWillMount() {
    const context = sessionStorage.getItem("context");
    const lgpd = sessionStorage.getItem("lgpd");

    if (window.location.pathname.endsWith("produtos")) {
      changePage(this.state.context.pathname);
    }

    if (context) {
      const contextObject = JSON.parse(context);
      contextObject.pathname = "/";
      this.setState({ context: contextObject });
    }

    axios
      .get("https://api.ipify.org?format=json")
      .then(({ data }) => (window.ip = data.ip));

    this.setState({ lgpd });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.context !== this.state.context) {
      sessionStorage.setItem("context", JSON.stringify(this.state.context));
    }
  }

  handleOnCloseLgpdModal = () => {
    sessionStorage.setItem("lgpd", true);
    this.setState((previousState) => ({
      context: { ...previousState.context, showLgpd: false },
    }));
  };

  render() {
    const fixedChat = (pathname) => {
      return pathname.endsWith("identificacao");
    };

    const pagename = this.state.context.pathname.replace("/", "");
    return (
      <AppContext.Provider
        value={{
          ...this.state.context,
          setContext: (context) => {
            if (context.pathname !== this.state.context.pathname) {
              changePage(context.pathname);
            }

            this.setState({ context });
          },
        }}
      >
        <main className={theme.main}>
          <Header />
          <div className={[theme.container, pagename].join(" ")}>
            <div className={[theme.content, pagename].join(" ")}>
              <div className={theme.innerContent}>
                {this.state.context.error.internalError &&
                  !this.state.context.modalOpen && (
                    <div className={theme.alertError}>
                      <Alert
                        error
                        title="Ops!"
                        text={this.state.context.error.internalError()}
                      />
                    </div>
                  )}

                <Switch>
                  <Route
                    path={"/produtos"}
                    render={(props) => <Products {...props} />}
                  />
                  <Route path={"/ofertas"} component={Offers} />
                  <Route path={"/identificacao"} component={Identification} />
                  <Route path={"/confirmar-oferta"} component={ConfirmOffer} />
                  <Route path={"/dados-cliente"} component={NewUser} />
                  <Route path={"/seguro"} component={Insurance} />
                  <Route path={"/pagamento"} component={Payment} />
                  <Route path={"/assinatura"} component={Signature} />
                  <Route
                    path={"/documentos/:proposalId"}
                    component={Documents}
                  />
                  <Route exact path={"/"} component={IBCInterceptor} />
                  <Redirect from={"/"} to={"/produtos"} />
                </Switch>
              </div>
            </div>
            {this.state.context.product &&
              !fixedChat(window.location.pathname) && (
                <Chat product={this.state.context.product} detached />
              )}
          </div>
          <Footer />
          <ModalLgpd
            open={!this.state.loading && this.state.context.showLgpd}
            onClick={this.handleOnCloseLgpdModal}
          />
          <ErrorModal />
          <MaintenanceModal />
          <AjaxSpinner loading={this.state.loading} />
        </main>
      </AppContext.Provider>
    );
  }
}

export default App;
